import { render, staticRenderFns } from "./TelaBase.vue?vue&type=template&id=83729e0c&scoped=true"
import script from "./TelaBase.vue?vue&type=script&setup=true&lang=js"
export * from "./TelaBase.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83729e0c",
  null
  
)

export default component.exports